export interface OrderCancellationStatus {
  code: string | number;
  label: string; // default label (in Spanish or English)
  translationKey: string;
  color: string;
  textColor: string;
}

export const ORDER_CANCELLATION_STATUS: Record<string, OrderCancellationStatus> = {
  '1': {
    code: '1',
    label: 'No cancelado',
    translationKey: 'orders.cancellation.notCanceled',
    color: '#87CBF6',
    textColor: 'rgba(0, 0, 0, 0.87)',
  },
  '2': {
    code: '2',
    label: 'Cancelación solicitada',
    translationKey: 'orders.cancellation.requested',
    color: '#FFB300',
    textColor: '#FFFFFF',
  },
  '3': {
    code: '3',
    label: 'Cancelación rechazada',
    translationKey: 'orders.cancellation.rejected',
    color: '#F44336',
    textColor: '#FFFFFF',
  },
  '4': {
    code: '4',
    label: 'Cancelado',
    translationKey: 'orders.cancellation.canceled',
    color: '#F44336',
    textColor: '#FFFFFF',
  },
  '5': {
    code: '5',
    label: 'Parcialmente cancelado',
    translationKey: 'orders.cancellation.partiallyCanceled',
    color: '#29B6F6',
    textColor: '#FFFFFF',
  },
  '6': {
    code: '6',
    label: 'Cancelación parcial solicitada',
    translationKey: 'orders.cancellation.partialRequested',
    color: '#FFB300',
    textColor: '#FFFFFF',
  },
};

export const getOrderCancellationStatus = (code: string | number): OrderCancellationStatus | undefined => {
  return ORDER_CANCELLATION_STATUS[String(code)];
};

export const getOrderCancellationStatusOptions = () =>
  Object.values(ORDER_CANCELLATION_STATUS).map((status) => ({
    value: status.code,
    label: status.label,
  }));